

import { API_BASE_URL } from './apiUtils';

export interface SupportMessage {
  username: string;
  message: string;
  timestamp: string;
}

export interface SendMessagePayload {
  username: string;
  message: string;
  timestamp: string;
}

export interface SendMessageResponse {
  success: boolean;
  messageId: string;
}

export interface GetMessagesResponse {
  message: string;
  result: SupportMessage[] | SupportMessage;
}

export const supportService = {
  /**
   * Send a support message
   */
  async sendMessage(payload: SendMessagePayload): Promise<SendMessageResponse> {
    try {
      const authTokens = localStorage.getItem('authTokens');
      let idToken = '';
      
      if (authTokens) {
        const tokens = JSON.parse(authTokens);
        idToken = tokens.IdToken;
      } else {
        throw new Error('Authentication required. Please login.');
      }

      const response = await fetch(`${API_BASE_URL}/helpdesk/send/message`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Error sending message: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error sending support message:', error);
      throw error;
    }
  },

  /**
   * Get support messages
   */
  async getMessages(): Promise<SupportMessage[]> {
    try {
      const authTokens = localStorage.getItem('authTokens');
      let idToken = '';
      
      if (authTokens) {
        const tokens = JSON.parse(authTokens);
        idToken = tokens.IdToken;
      } else {
        throw new Error('Authentication required. Please login.');
      }

      const response = await fetch(`${API_BASE_URL}/helpdesk/get/message`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${idToken}`
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching messages: ${response.status}`);
      }

      const data: GetMessagesResponse = await response.json();
      console.log('API Response:', data);
      
      // Ensure we always return an array
      if (!data.result) {
        return [];
      }
      
      // If result is a single object, wrap it in an array
      if (!Array.isArray(data.result)) {
        return [data.result];
      }
      
      // If result is already an array, return it
      return data.result;
    } catch (error) {
      console.error('Error fetching support messages:', error);
      throw error;
    }
  }
};

